const textColors = {
  colors: [
    {
      color: '#000000',
      label: 'Black'
    },
    {
      color: '#4d4d4d',
      label: 'Dim grey'
    },
    {
      color: '#999999',
      label: 'Grey'
    },
    {
      color: '#e6e6e6',
      label: 'Light grey'
    },
    {
      color: '#ffffff',
      label: 'White',
      hasBorder: true
    },
    {
      color: '#ff0000',
      label: 'Red'
    },
    {
      color: '#ff9900',
      label: 'Orange'
    },
    {
      color: '#ffff00',
      label: 'Yellow'
    },
    {
      color: '#00ff00',
      label: 'Bright green'
    },
    {
      color: '#008000',
      label: 'Green'
    },
    {
      color: '#00ccff',
      label: 'Light blue'
    },
    {
      color: '#0066cc',
      label: 'Blue'
    },
    {
      color: '#6600cc',
      label: 'Purple'
    },
    {
      color: '#ff00ff',
      label: 'Magenta'
    },
    {
      color: '#ff66cc',
      label: 'Pink'
    }
  ],
  columns: 5,
  documentColors: 10
}

export default textColors
